<template>
  <div class="transferBox">
    <div class="search-wrapper">
      <div class="search-left">
        <div class="station start-station" @click="goToSearch('start')">
          <div class="circle start-circle"></div>
          <div class="station-name has-station" v-if="startStation.name">{{startStation.name}}</div>
          <div class="station-name no-station" v-else>请输出起始站</div>
        </div>
        <div class="station" @click="goToSearch('end')">
          <div class="circle end-circle"></div>
          <div class="station-name has-station" v-if="endStation.name">{{endStation.name}}</div>
          <div class="station-name no-station" v-else>请输出终点站</div>
        </div>
      </div>
      <div class="search-right" @click="changeStation">
        <div class="iconfont icon-zhuanhuan"></div>
      </div>
    </div>
    <div class="history" v-if="searchData.length">
      <div class="history-tip">
        <div class="tip-word">历史记录</div>
        <div class="iconfont icon-shanchu" @click="clearHisory"></div>
      </div>
      <div class="history-box">
        <div class="station-box">
          <div class="station-name" v-for="(item, index) in searchData" :key="index" @click="historyCheck(item)">
            <div class="iconfontT iconfont icon-weizhi"></div>
            <div class="item-name">{{item.startName}} - {{item.endName}}</div>
            <div class="iconfontW iconfont icon-shanchu2" @click.stop="clearItem(item)"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="no-data" v-if="!searchData.length">
      <div class="iconfont icon-wushuju"></div>
      <div class="word">暂无数据~</div>
    </div>
    <!-- 标签栏 -->
    <div class="tabBox">
      <van-tabbar v-model="active">
        <van-tabbar-item icon="logistics" @click="goToHome">出行</van-tabbar-item>
        <van-tabbar-item icon="exchange" >导乘</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Notify } from 'vant'
import { setTimeout } from 'timers';
export default {
  name: "transfer",
  components: {
  },
  data () {
    return {
      active: 1,
      startStation: {},
      endStation: {},
      searchData: []
    }
  },
  computed: {
    ...mapGetters(['upStation', 'downStation'])
  },
  mounted () {
    this.$wxHide()
    this.getHistory()
    let backParams = this.$route.params.backSearchObj
    if (backParams) {
      if (backParams.type === 'start') {
        this.endStation = this.downStation
        if (this.checkSame(backParams, this.endStation)) {
          this.startStation = {}
          Notify({ type: 'danger', message: '起点站和终点站一样了！' })
        } else {
          this.startStation = backParams || this.upStation
        }
      } else if (backParams.type === 'end') {
        this.startStation = this.upStation
        if (this.checkSame(backParams, this.startStation)) {
          this.endStation = {}
          Notify({ type: 'danger', message: '起点站和终点站一样了！' })
        } else {
          this.endStation = backParams || this.downStation
        }
      }
    } else {
      this.startStation = this.upStation
      this.endStation = this.downStation
    }
    setTimeout(() => {
      this.autoSearch()
    }, 1000)
  },
  methods: {

    goToHome () {
      this.$router.push({ name: "home" })
    },
    goToSearch (str) {
      this.$session.setLocalStorage('searchType', str)
      this.$router.push({name: 'searchStation', params: { searchType: str }})
    },
    checkSame (myself, child) {
      return myself.name === child.name
    },
    changeStation () {
      const cicheObj = this.startStation
      this.startStation = this.endStation
      this.startStation.type = 'start'
      this.endStation = cicheObj
      this.endStation.type = 'end'
      this.$store.dispatch('save_startStation', this.startStation)
      this.$store.dispatch('save_endStation', this.endStation)
    },
    autoSearch () {
      if (this.startStation.name && this.endStation.name) {
        const params = {
          startName: this.startStation.name,
          endName: this.endStation.name,
          startStation: this.startStation,
          endStation:  this.endStation
        }
        this.searchData.unshift(params)
        this.$session.setLocalStorage('searchData', this.searchData)
        this.$session.setLocalStorage('mapLineStation', params)
       this.$router.push({name: 'mapLine', params: {backSearchObj: params}})
        this.$store.dispatch('save_startStation', {})
        this.$store.dispatch('save_endStation', {})
      }
    },
    getHistory () {
      let storageData = this.$session.getLocalStorage('searchData')
      if (storageData) {
        if (storageData.length) {
          let arr = [storageData[0]]
          for (let i = 1; i < storageData.length; i++) {
            var repeatData = false
            for (var j = 0; j < arr.length; j++) {
              console.log()
              if (storageData[i]['startName'] === arr[j]['startName'] && storageData[i]['endName'] === arr[j]['endName']) {
                repeatData = true
                break
              }
            }
            if (!repeatData) {
              arr.push(storageData[i])
            }
          }
          this.searchData = arr
        } else {
          this.searchData = []
        }
      }
    },
    clearHisory () { 
      this.$session.removeLocalStorage('searchData')
      this.searchData = []
    },
    clearItem (item) {
      this.searchData = this.searchData.filter(n => (item.startName !== n.startName && item.endName !== n.endName))
      this.$session.setLocalStorage('searchData', this.searchData)
    },
    historyCheck (item) {
      this.searchData.unshift(item)
      this.$session.setLocalStorage('searchData', this.searchData)
      this.$session.setLocalStorage('mapLineStation', item)
      this.$router.push({name: 'mapLine', params: {backSearchObj: item}})
    }
  }
};
</script>

<style lang="scss" scoped>
.transferBox {
  background: #F8F8F8;
  height: 100%;
  overflow: hidden;
  .search-wrapper {
    width: auto;
    height: 1rem;
    display: flex;
    align-items: center;
    margin: 0.1rem;
    background: #ffffff;
    box-shadow: 2px 2px 13px 1px #DDE2F7;
    border-radius: 10px;
    .search-left {
      flex: 1 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 0.2rem;
      .station {
        width: 100%;
        height: 0.5rem;
        background: #ffffff;
        display: flex;
        align-items: center;
        &.start-station {
          border-bottom: 1px solid #eeeeee;
        }
        .circle {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          overflow: hidden;
          &.start-circle {
            background: #16a951;
          }
          &.end-circle {
            background: #f00056;
          }
        }
        .station-name {
          flex: 1 auto;
          padding: 0rem 0.1rem;
          font-size: 16px;
          &.has-station {
            color: #000000;
            font-weight: 800;
          }
          &.no-station {
            color: #999999;
          }
        }
        .iconfont {
          font-size: 12px;
        }
      }
    }
    .search-right {
      width: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      .iconfont {
        font-size: 20px;
        // background: #ffffff;
        padding: 5px;
        border-radius: 50%;
        color:#536ADA
      }
    }
  }
  .history {
    width: 100%;
    height: calc(100vh - 170px);
    overflow: hidden;
    .history-tip {
      width: auto;
      height: 40px;
      margin: 0px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .tip-word {
        width: 100px;
        font-size: 18px;
        color: #333;
        font-weight:bold
      }
      .icon-shanchu{
        color:#536ADA;
        font-size:18px
      }
      // .iconfont {
      //   font-size: 22 px;
      // }
    }
    .history-box {
      width: auto;
      height: calc(100vh - 210px);
      padding: 0 10px;
      overflow: auto;
      .station-box {
        background: #ffffff;
        box-shadow: 2px 2px 13px 1px #DDE2F7;
        border-radius: 10px;
        .station-name {
          width: auto;
          height: 50px;
          padding: 0 10px;
          font-size: 14px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid  #eeeeee;
        }
        .iconfontT {
          // width: 30px;
          color: #1989fa;
        }
        .iconfontW {
          color: #999999;
        }
        .item-name {
          flex: 1 auto;
          margin: 0px 5px;
        }
      }
      
    }
  }
  .no-data {
    width: 100%;
    height: calc(100vh - 170px);
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    .iconfont {
      font-size: 100px;
      margin: 20vh auto 10px;
      color: #999999;
    }
    .word {
      font-size: 14px;
      color: #999999;
    }
  }
}
</style>
